// React
import React from 'react';

// Packages
import t from 'prop-types';

// Utilities
import { useLabels, useFormat } from 'utilities/hooks';

// Components
import ActivityTags from '../_common/activityTags';
import Card from 'components/_cardContentElements';

const ActivityTeamEducationComponent = ({
    item,
    theme = 'teal',
    utilities,
    wrap = false,
}) => {
    // ///////////////////
    // HOOKS
    // ///////////////////

    const format = useFormat();
    const { object } = useLabels();

    // ///////////////////
    // DATA
    // ///////////////////

    const employees = utilities.activityEmployees.getFromActivityId(item?.Id);

    const {
        Things_To_Do_Description__c,
        Activity_Start_Date__c,
        Activity_End_Date__c,
    } = item;

    // ///////////////////
    // RENDER
    // ///////////////////

    return (
        <Card.CardContentWrapper
            {...{
                wrap,
            }}>
            {/* Description */}
            {Things_To_Do_Description__c && (
                <Card.CardContentSection
                    {...{
                        theme,
                        wrap,
                    }}>
                    <p>{Things_To_Do_Description__c}</p>
                </Card.CardContentSection>
            )}

            {/* Start date / End date  */}
            {Activity_Start_Date__c && (
                <Card.CardContentSection
                    {...{
                        theme,
                        wrap,
                        title: object.label(
                            'Initiative_Activity__c.Dates_Label'
                        ),
                    }}>
                    <p>
                        {format.date(Activity_Start_Date__c)}
                        {Activity_End_Date__c
                            ? ` - ${format.date(Activity_End_Date__c)}`
                            : ''}
                    </p>
                </Card.CardContentSection>
            )}

            {/* Details */}
            <ActivityTeamEducationDetails
                {...{ item, theme, employees, wrap }}
            />

            {/* Tags */}
            <ActivityTags {...{ item, theme }} />
        </Card.CardContentWrapper>
    );
};

const ActivityTeamEducationDetails = ({
    item,
    theme,
    employees,
    wrap = false,
}) => {
    // ///////////////////
    // HOOKS
    // ///////////////////

    const { object } = useLabels();

    // ///////////////////
    // RENDER
    // ///////////////////

    return (
        <>
            {/* Employees */}
            {employees.length > 0 && (
                <Card.CardContentSection
                    {...{
                        theme,
                        wrap,
                        title: object.label(
                            'Initiative_Activity__c.Employee__c'
                        ),
                    }}>
                    <ul>
                        {employees.map(x => (
                            <li key={x.Id}>
                                -{' '}
                                {`${x?.Initiative_Employee_Funded__r?.Full_Name__c} - ${x?.Initiative_Employee_Funded__r?.Job_Title__c}`}
                            </li>
                        ))}
                    </ul>
                </Card.CardContentSection>
            )}
        </>
    );
};

ActivityTeamEducationComponent.propTypes = {
    item: t.object,
};

ActivityTeamEducationComponent.defaultProps = {};

export { ActivityTeamEducationDetails };
export default ActivityTeamEducationComponent;
